import { Navigate } from "react-router-dom";
import PublicHome from "@/pages/public/PublicHome";
import ResourceStatus from "../components/ResourceStatus";
import useResource from "../hooks/useResource";
import { getDomainEntryContext } from "../services/tenant";

const normalizeHost = value => String(value || "").trim().toLowerCase().replace(/\.$/, "");

/** Domain entry selection only; the existing tenant routes enforce access. */
export default function DomainRootRoute() {
  const { data, loading, error, reload } = useResource(getDomainEntryContext);
  if (loading) return <ResourceStatus loading label="Loading…" />;

  const hostname = normalizeHost(window.location.hostname);
  const backoffice = data?.merchant?.id && Array.isArray(data.domains) && data.domains.some(domain =>
    domain && normalizeHost(domain.domain) === hostname
      && String(domain.domain_type || "").toUpperCase() === "BACKOFFICE"
      && String(domain.status || "").toUpperCase() !== "DISABLED");
  if (backoffice) return <Navigate to="/login" replace />;

  // A default merchant is not a hostname mapping. Keep the public site usable
  // when no mapping applies or its optional domain lookup is unavailable.
  return <>
    {error && <div className="relative z-[1100] bg-background">
      <ResourceStatus error="Unable to check this domain’s entry page." onRetry={reload} size="compact" />
    </div>}
    <PublicHome />
  </>;
}
